// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14ucy","controls":"styles_controls__1SRPv","charLimit":"styles_charLimit__3eGQT","input":"styles_input__2nuGi","send":"styles_send__1ObwY"};